<!doctype html>
<html lang="en">

<head>
    <title>HT | Brunch</title>
    <meta charset="utf-8">
</head>

<body>
    <div class="container">
        <div class="header">
            <img src="../../../assets/images/brunch-logo.png" alt="logo" width="120px">
        </div>
        <div class="content_inner">
            <div class="content_inner">
                <h1>{{brunchItem.headline}}
                </h1>
                <p [innerHtml]="brunchItem.summary"></p>
                <div *ngIf="lastPublishedDate" class="publish">Published on {{lastPublishedDate}}</div>
                <div class="follow-div">
                    <div class="follow_left">
                        <p *ngIf="brunchItem.byLine" class="follow-head">By - {{brunchItem.byLine}}</p>
                    </div>
                </div>
                <figure *ngIf="brunchItem.image">
                    <img src="{{brunchItem.image.images.original}}" alt="Musician Mohammad Muneem">
                    <figcaption [ngClass]="{'caption_out' : !brunchItem.image.overImage}">
                        <h4>{{brunchItem.image.caption}}</h4>
                        <p *ngIf="brunchItem.image.imageCredit">{{brunchItem.image.imageCredit}}</p>
                    </figcaption>
                </figure>

                <ng-container *ngIf="brunchItem.video">
                    <div class="respVideo" [innerHtml]="brunchItem.video.body | noSanitize">
                    </div>
                </ng-container>

                <ng-container *ngFor="let storyId of storyElementArray">
                    <app-brunch-element [storyelementId]="storyId"></app-brunch-element>
                </ng-container>
            </div>
        </div>
    </div>
</body>

</html>